import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  current = new BehaviorSubject<any>(null);

  constructor() { }

  getCurrentTheme(){
    return this.current.asObservable();
  }

  setTheme(newTheme: any){
    this.current.next(newTheme);
  }
}
